import { render, staticRenderFns } from "./Form6.vue?vue&type=template&id=7328b2ba&scoped=true&"
import script from "./Form6.vue?vue&type=script&lang=ts&"
export * from "./Form6.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7328b2ba",
  null
  
)

export default component.exports